import { connect } from 'react-redux'
import TopicLayer from '../components/TopicLayer'
import { togglePeriodLayer } from '../redux/modules/timeline'
import {
  selectedTopicSelector,
  activeSelector,
  currentPhaseSelector,
  getPeriodLayerVisibility,
} from '../redux/selector'

const mapStateToProps = state => ({
  show: activeSelector(state),
  topic: selectedTopicSelector(state),
  text: currentPhaseSelector(state).text,
  expand: getPeriodLayerVisibility(state),
})

const mapDispatchToProps = dispatch => ({
  clickHandler: () => {
    dispatch(togglePeriodLayer())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicLayer)
